import { MoreVert } from "@mui/icons-material";
import { IconButton, IconButtonProps, Stack, Tooltip } from "@mui/material";

interface IContextMenuIconButtonProps extends IconButtonProps {
  isVisible?: boolean;
  active?: boolean;
  tooltipTitle?: string;
}

export const ContextMenuIconButton: React.FC<IContextMenuIconButtonProps> = (props) => {
  const { isVisible, active, tooltipTitle, onClick } = props;
  return (
    <Stack sx={{ direction: "row", alignItems: "flex-end", justifyContent: "flex-end" }}>
      <Tooltip title={tooltipTitle} placement="left">
        <span>
          <IconButton
            id="context-menu-icon-button"
            onClick={onClick}
            sx={(theme) => ({
              visibility: !isVisible ? "hidden" : "visible",
              backgroundColor: active ? theme.palette.grey[300] : "transparent",
            })}
            aria-label="context-menu-button"
          >
            <MoreVert
              sx={{
                fontSize: 20,
                color: "text.primary",
              }}
            />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
